import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { SalesOrder } from '@/hooks/api/models';

/**
 * 2610. board案件名同期
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sync_board_project_name
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
};
export const syncBoardProjectName = (props: Props): Promise<SalesOrder> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sync_board_project_name`,
    props
  );
};

export const useSyncBoardProjectName = () => {
  return useMutation({
    mutationFn: syncBoardProjectName,
  });
};
